/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Menu, MenuItem } from '@mui/material';

const ButtonMenuV2 = ({ options, title }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        color="primary"
        variant="contained"
        onClick={handleClick}
        sx={{ mr: 2, mt: 0.5 }}
      >
        {title}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {options.map((data, index) =>
          (data.show === undefined || data.show) ? (
            <MenuItem
              key={data.title || index}
              onClick={() => {
                handleClose();
                data.onClick();
              }}
            >
              {data.title}
            </MenuItem>
          ) : null
        )}
      </Menu>
    </>
  );
};

ButtonMenuV2.propTypes = {
  options: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
};

export default ButtonMenuV2;
